<template>
  <q-dialog :value="open" @hide="closeDialog">
    <q-card v-if="open" style="width:clamp(200px,400px,400px)">
      <q-card-section class="text-center">
        <div class="text-h6 text-weight-medium">{{dialogHeading}}</div>
      </q-card-section>
      <q-separator />
      <q-card-section class="q-gutter-y-sm">

        <q-input
          label="Name"
          dense
          v-model="referrerItem.name"
        />
        <q-input
          label="Deposit Amount"
          type="number"
          dense
          v-model.number="referrerItem.depositAmount"
        />
        <q-input
          label="Lead Cost"
          type="number"
          dense
          v-model.number="referrerItem.leadCost"
        />
      </q-card-section>
      <q-separator />
      <q-card-actions align="right">
        <q-btn
          label="Save"
          color="primary"
          :loading="saving"
          @click="handleSave"
          v-if="canUpdatePermissions"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import graphql from '@client/graphql';
import { assessPermission } from '@server/lib/permission-helpers';

const referrerItemObject = {
            name: '',
            depositAmount: '',
            leadCost: ''
          };

export default {
  apollo: {
    currentUser: {
      query: graphql.queries.currentUser
    }
  },
  data() {
    return {
        open: false,
        saving: false,
        referrerItem: { ...referrerItemObject }
    };
  },
  computed: {
    canUpdatePermissions() {
      return assessPermission.taq.canUpdate(this.currentUser);
    },
    dialogHeading() {
      return this.referrerItem.id ? 'Update Referrer' : 'Add Referrar';
    }
  },
  methods: {
    openDialog(referrer = {}) {
      this.open = true;
      this.referrerItem = { ...referrerItemObject, ...referrer };
    },
    closeDialog() {
      this.open = false;
    },
    handleRoleChange(role) {
      this.role = role;
    },
    async handleSave() {
      this.saving = true;
      const { id, slug, __typename, ...input } = this.referrerItem;
      input.depositAmount = Number(input.depositAmount);
      input.leadCost = Number(input.leadCost);

      const data = {
        input
      };
      if (id) data.id = Number(id);
      try {
        await this.$apollo.mutate({
          mutation: id ? graphql.mutations.updateReferrer : graphql.mutations.createReferrer,
          variables: data
        });
        this.notifyPositive('Referrer Saved!');
        this.referrerItem = { ...referrerItemObject };
        if (!id) this.$emit('referrerAdded');
        this.closeDialog();
      } catch (error) {
        this.notifyNegative(`Error Saving Referrer! : ${error.message}`);
      }
      this.saving = false;
    }
  }
};
</script>

<style></style>
